// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import './styles.scss';

// Assets

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { useSelector } from 'react-redux';
import { Spin, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { Fade } from 'react-reveal';
import Banner from 'components/commonComponents/Banner';
import { APP_ID } from 'config/constants';
import { useNavigate } from 'react-router-dom';
import Logo from 'assets/images/logo.png'
import Button from 'components/commonComponents/Button';
import SocialShare from 'components/modals/SocialShare';
import WalletRedeem from 'components/modals/WalletRedeem';

// Enough of the app's description to say what it is, short enough to survive
// a messaging app's preview.
const DESCRIPTION_LIMIT = 250;

const ReferAndEarn = () => {
    const { currentLang, userDetails } = useSelector((store) => store.commonData);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [wallet, setWallet] = useState(null);
    const [appInfo, setAppInfo] = useState(null);
    const [summary, setSummary] = useState('');
    const [openShareSocial, setOpenShareSocial] = useState(false);
    const [openRedeem, setOpenRedeem] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    // The reader's own code; a friend enters it, or follows the link below.
    const referralCode = userDetails?.refCode ? userDetails?.refCode : userDetails?.userId ? userDetails?.userId : '';
    const referralUrl = window.location.origin + '/subscribe?refcode=' + encodeURIComponent(referralCode);

    const fetchWallet = async () => {
        const res = await fetchData(restAPIs.getWallet(APP_ID, currentLang?.id));
        if (res.statusCode === 200) {
            // wallet.php answers in the platform's paged envelope: the balance,
            // heading and prose arrive as the single row under `entities`. An
            // empty `entities` is not an error — a referrer who has earned
            // nothing has no row yet.
            const row = res?.entities?.length ? res.entities[0] : res?.wallet ? res : null;
            if (row) {
                setWallet({
                    balance: Number(row.wallet ? row.wallet : 0),
                    currency: row.currency ? row.currency : '',
                    title: row.title ? row.title : '',
                    description: row.description ? row.description : '',
                    hasRecord: true
                })
            } else {
                setWallet({ balance: 0, currency: '', title: '', description: '', hasRecord: false })
            }
        }
        setLoading(false);
    }

    const fetchAppinfo = async () => {
        const res = await fetchData(restAPIs.getAppInfo(APP_ID, currentLang?.id));
        if (res?.appInfo) {
            const tempRes = res?.appInfo
            setAppInfo(tempRes)
            var temp_appInfo = tempRes;
            var appStoreLink = temp_appInfo.appStoreLink ? temp_appInfo.appStoreLink : '';
            var googleStoreLink = temp_appInfo.googleStoreLink
                ? temp_appInfo.googleStoreLink
                : '';
            var websitelink = temp_appInfo.websitelink ? temp_appInfo.websitelink : window.location.origin;
            var name = temp_appInfo.name ? temp_appInfo.name : t('hawaya').trim();
            var subbody = temp_appInfo.description ? temp_appInfo.description : '';
            subbody = subbody.replace(/<style([\s\S]*?)<\/style>/gi, '');
            subbody = subbody.replace(/<script([\s\S]*?)<\/script>/gi, '');
            subbody = subbody.replace(/<\/div>/gi, '\n');
            subbody = subbody.replace(/<\/li>/gi, '\n');
            subbody = subbody.replace(/<li>/gi, '  *  ');
            subbody = subbody.replace(/<\/ul>/gi, '\n');
            subbody = subbody.replace(/<\/p>/gi, '\n');
            subbody = subbody.replace(/<br\s*\/?>/gi, '\n');
            subbody = subbody.replace(/<[^>]+>/gi, '');
            subbody = subbody.replace(/&nbsp;/gi, '');
            subbody = subbody.replace(/\n+/g, ' ').trim();
            if (subbody.length > DESCRIPTION_LIMIT)
                subbody = subbody.slice(0, DESCRIPTION_LIMIT).trimEnd() + '…';

            // Lines without a value are dropped rather than printed empty:
            // `Play Store : ` on its own reads as a broken message. The share
            // sheet appends the referral link after the last line.
            var lines = [
                name,
                subbody,
                appStoreLink ? t('app_store') + ' : ' + appStoreLink : '',
                googleStoreLink ? t('play_store') + ' : ' + googleStoreLink : '',
                t('website') + ' : ' + websitelink,
            ].filter((line) => line.trim() !== '');

            setSummary(lines.join('\n') + '\n\n' + t('discounted_subscription') + ' :')
        }
        setLoading(false);
    }

    useEffect(() => {
        setLoading(true)
        fetchWallet();
        fetchAppinfo();
        window.scrollTo(0, 0);
    }, [currentLang]);

    useEffect(() => {
        if (!userDetails) {
            navigate('/home')
        }
    }, []);

    const handleCloseShareSocial = () => {
        setOpenShareSocial(false);
    };

    const handleOpenShareSocial = () => {
        setOpenShareSocial(true);
    };

    const handleCopyCode = () => {
        navigator.clipboard.writeText(referralCode).then(
            () => messageApi.open({ type: 'success', content: t('copied_to_clipboard') }),
            () => messageApi.open({ type: 'error', content: t('something_went_wrong_try_after_sometime') })
        );
    };

    const handleRedeemed = () => {
        setOpenRedeem(false);
        // The payout is settled by a person, so the figure does not change
        // here; refetching is how the screen learns when it does.
        setLoading(true);
        fetchWallet();
    };

    return (
        <>
            <Banner title={t('my_wallet')} />
            <div className='container __innerTopPad'>
                {contextHolder}
                {isLoading ?
                    <div className='text-center'>
                        <Spin className='__spin_color' size="large" tip="Loading" />
                    </div> :
                    <div className='row'>
                        <Fade bottom cascade>
                            <div className='col-md-3 mb-5'>
                                <img src={Logo} alt="" width={'100%'} height={'200px'} style={{ objectFit: 'contain' }} />
                            </div>
                        </Fade>
                        <Fade bottom cascade>
                            <div className='col-md-9 mb-5'>
                                <h4 style={{ color: '#a19c74', marginBottom: '10px' }}>{t('refer_earn')}</h4>
                                {wallet?.hasRecord ?
                                    <h1 className='__common-head' style={{ color: '#4095FF', fontSize: '2rem' }}>{t('wallet_money')} : <span dir="ltr">{wallet?.balance}</span> {wallet?.currency ? wallet?.currency : t('ev_points')}</h1>
                                    :
                                    <>
                                        <h1 className='__common-head' style={{ color: '#4095FF', fontSize: '2rem' }}>{t('no_points_yet')}</h1>
                                        <p style={{ fontSize: '17px' }}>{t('points_appear_hint')}</p>
                                    </>
                                }
                                {referralCode &&
                                    <div className='wallet_referral_code'>
                                        <h5 style={{ color: '#a19c74' }}>{t('your_referral_code')}</h5>
                                        <p>
                                            <code dir="ltr" style={{ fontSize: '20px' }}>{referralCode}</code>
                                            <a onClick={handleCopyCode} style={{ cursor: 'pointer', margin: '0 10px' }}><CopyOutlined /> {t('copy_code')}</a>
                                        </p>
                                        <h5 style={{ color: '#a19c74' }}>{t('your_referral_link')}</h5>
                                        <p dir="ltr" style={{ wordBreak: 'break-all' }}>{referralUrl}</p>
                                    </div>
                                }
                                <h4 style={{ color: '#a19c74', margin: '20px 0 10px' }}>{wallet?.title ? wallet?.title : t('how_it_works')}</h4>
                                <p dangerouslySetInnerHTML={{ __html: wallet?.description }} style={{ lineHeight: '2', fontSize: '17px' }}></p>
                                <p style={{ fontSize: '15px', opacity: '0.8' }}>{t('redeem_points_hint')}</p>
                            </div>
                        </Fade>
                    </div>
                }   <div className='wallet_footer_button'>
                    {wallet?.balance > 0 &&
                        <Button
                            className='mb-1'
                            handleOnClick={() => setOpenRedeem(true)}
                            style={{ width: '100%', height: '40px', background: '#e3a83a' }}
                            label={t('redeem')} />
                    }
                    <Button
                        className='mb-1'
                        handleOnClick={handleOpenShareSocial}
                        style={{ width: '100%', height: '40px' }}
                        label={t('share_now')} />
                </div>
                <SocialShare
                    open={openShareSocial}
                    onClose={handleCloseShareSocial}
                    title={appInfo?.name}
                    description={appInfo?.description}
                    image={appInfo?.logo}
                    url={referralUrl}
                    summary={summary}
                />
                <WalletRedeem
                    open={openRedeem}
                    onClose={() => setOpenRedeem(false)}
                    onRedeemed={handleRedeemed}
                />
            </div>
        </>
    );
};

export default ReferAndEarn;
